<script setup lang="ts">
withDefaults(
  defineProps<{
    columns: {
      title: string
      field: string
      align:'left'|'center'|'right'
    }[]
    data: {
      [p: string]: any
    }
  }>(),
  {
    columns: () => [],
    data: () => [],
  }
)
</script>

<template>
  <div class="cb-table">
    <table>
      <thead>
        <tr>
          <template v-for="column in columns">
            <th>{{ column.title }}</th>
          </template>
        </tr>
      </thead>
      <tbody>
        <template v-for="row in data">
          <tr>
            <template v-for="column in columns">
              <td :style=" { 'text-align': column.align||'left' }" >
                <slot>
                  {{ row[column['field']] }}
                </slot>
              </td>
            </template>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>

<style scoped lang="scss">
.cb-table {
  border: 1px solid #c2e999;
  border-radius: 0.48rem;
  width: 100%;
  overflow: auto;

  table {
    min-width: 100%;
    background-image: linear-gradient(90deg, #9ad847, #4ac971);
    table-layout: fixed;
    border-spacing: 0;
  }

  thead {
    color: #fff;

    th {
      height: 0.893rem;
      font-size: 0.72rem;
    }
  }

  th,
  td {
    white-space: nowrap;
    border: none;
    padding: 0 0.6rem;
  }

  tbody {
    color: #666;

    td {
      border-top: 1px solid #8dd053;
      height: 0.84rem;
      font-size: 0.586rem;
    }

    tr {
      &:nth-child(odd) {
        background-color: #ffffff;
      }

      &:nth-child(even) {
        background-color: #fbfff5;
      }
    }
  }
}
</style>
